<template>
  <div>
    <v-dialog
      v-model="value"
      max-width="400"
      @keydown.esc="this.$emit('input' , false)"
      @click:outside="$emit('input', false)"
    >
      <v-card>
        <v-card-title>
          <v-icon left>mdi-pencil</v-icon>{{ $t('area.edit_stall_location') }}
        </v-card-title>
        <v-card-text>
          <h2 v-if="market">{{ market.name }}</h2>
          <p class="mb-1">{{ $t('area.latitude') }}</p>
          <v-text-field
            flat
            solo
            type="number"
            step="0.000001"
            background-color="grey lighten-3"
            name="name"
            :label="$t('input_data')"
            :placeholder="$t('input_data')"
            v-model="form.latitude"
          ></v-text-field>
          <p class="mb-1">{{ $t('area.longitude') }}</p>
          <v-text-field
            flat
            solo
            type="number"
            step="0.000001"
            background-color="grey lighten-3"
            :label="$t('input_data')"
            :placeholder="$t('input_data')"
            v-model="form.longitude"
          ></v-text-field>
          <v-btn
            @click="getCurrentGeo()"
            text
            class="text-decoration-underline"
            color="info"
          >{{ $t('market.get_current_location_data') }}</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="isLoading"
            color="error"
            elevation="0"
            @click.native="$emit('input' , false)"
          >{{ $t('cancel') }}</v-btn>
          <v-btn
            :loading="isLoading"
            color="primary"
            elevation="0"
            @click="updateArea"
            :disabled="!form.latitude || !form.longitude || isLoading"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isError" color="error">{{ $t('validate.error_add_market_area') }}</v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    market: Object,
    area: Object
  },
  data() {
    return {
      isError: false,
      isLoading: false,
      form: {
        name: "",
        size: ""
      }
    };
  },
  watch: {
    value() {
      if (this.area) {
        this.form = {
          id: this.area.objectId,
          latitude: null,
          longitude: null
        };
        if (this.area.location) {
          this.form.latitude = this.area.location.latitude;
          this.form.longitude = this.area.location.longitude;
        }
      } else {
        this.form = {
          latitude: null,
          longitude: null
        };
      }
    }
  },
  methods: {
    async updateArea() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("area/updateArea", {
          id: this.form.id,
          latitude: this.form.latitude,
          longitude: this.form.longitude,
          marketId: this.market.objectId
        });
        this.isLoading = false;
        this.$emit("input", false);
        this.$emit("onSuccess", true);
      } catch (error) {
        this.isError = true;
        this.isLoading = false;
      }
    },
    async getCurrentGeo() {
      if (navigator.geolocation) {
        let data = null;
        navigator.geolocation.getCurrentPosition(
          d => {
            if (d.coords) {
              this.form.latitude = d.coords.latitude;
              this.form.longitude = d.coords.longitude;
              this.$toast.show({
                content: this.$t('market.success_get_current_location_data'),
                color: "success"
              });
            } else {
              this.$toast.show({
                content: this.$t('market.no_current_location_data'),
                color: "error"
              });
            }
          },
          err => {
            this.$toast.show({
              content: `ERROR(${err.code}): ${err.message}`,
              color: "error"
            });
          },
          {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
        );
      } else {
        this.$toast.show({
          content: `Geolocation is not supported by this browser.`,
          color: "error"
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
